module.exports = __webpack_public_path__ + "24cf1445295380442cba665efe3e13a0.jpg";